import openSocket from 'socket.io-client'

const socket = openSocket(`${process.env.REACT_APP_DOMAIN}/`, { transports: ['websocket'] })

socket.on('connect', function () {})

function bidAddtime(cb) {
    socket.on('bidAddtime', (data) => {
        cb(data)
    })
}

function realClosedUpdates(cb) {
    socket.on('realclosedupdates', (data) => {
        cb(data)
    })
}

function refreshbuyer(cb) {
    socket.on('refreshbuyer', (data) => {
        cb(data)
    })
}
function refreshbuyerOff() {
    socket.off('refreshbuyer')
}
function bid_extended(cb) {
    socket.on('bid_extended', (data) => {
        cb(data)
    })
}
function bid_extendedOff() {
    socket.off('bid_extended')
}
function sendmessage() {
    socket.on('sendmessage', (data) => {
        cb(data)
    })
}
socket.on('disconnect', function () {
    console.log('Socket Disconnected')
})
export {
    bidAddtime,
    realClosedUpdates,
    refreshbuyer,
    sendmessage,
    socket,
    refreshbuyerOff,
    bid_extended,
    bid_extendedOff,
}
